export default "__VITE_ASSET__DUjO3ckM__"